import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Reports_custom_ds_get_pallet_detailsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { orderId?: number, shipmentId?: number }): 
  Promise<{ result: { OrderId?: number, ShipmentId?: number, Shipment?: { Id?: number, LoadContainerId?: number, PalletTransactions?: { Amount?: number, PalletClassId?: number, PalletClass?: { Name?: string } }[], LoadContainer?: { Id?: number, LoadContainerContainerTypeId?: number, LookupCode?: string, ContainerType?: { Id?: number, Name?: string } } } }[] }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { orderId?: number, shipmentId?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { OrderId?: number, ShipmentId?: number, Shipment?: { Id?: number, LoadContainerId?: number, PalletTransactions?: { Amount?: number, PalletClassId?: number, PalletClass?: { Name?: string } }[], LoadContainer?: { Id?: number, LoadContainerContainerTypeId?: number, LookupCode?: string, ContainerType?: { Id?: number, Name?: string } } } }[], totalCount: number }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { orderId?: number, shipmentId?: number, $keys: { OrderId?: number, ShipmentId?: number }[] }): 
  Promise<{ result: { OrderId?: number, ShipmentId?: number, Shipment?: { Id?: number, LoadContainerId?: number, PalletTransactions?: { Amount?: number, PalletClassId?: number, PalletClass?: { Name?: string } }[], LoadContainer?: { Id?: number, LoadContainerContainerTypeId?: number, LookupCode?: string, ContainerType?: { Id?: number, Name?: string } } } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      orderId?: number, shipmentId?: number    }) {
      return false;
    }
}
